import { tableCellStrings } from './strings';

const formatValueIfNull = (value) =>
  !value || value === '' ? tableCellStrings.dash : value;
export default formatValueIfNull;
